module.exports = __webpack_public_path__ + "img/Cracked Stone.1fc4556b.png";